"use client";

import { Typography } from "@grupa-pracuj/ui-system";
import { useSearchParams } from "next/navigation";
import { useEffect, useRef } from "react";
import { getMonthName, getResolvedArchiveSearchParams } from "@/utils";
import styles from "./DynamicHeader.module.css";

const DynamicHeader = () => {
  const headingRef = useRef<HTMLHeadingElement>(null);
  const isFirstRender = useRef(true);
  const searchParams = useSearchParams();
  const { year, month, pageNumber } = getResolvedArchiveSearchParams({
    year: searchParams.get("year"),
    month: searchParams.get("month"),
    pageNumber: searchParams.get("pageNumber"),
  });
  const focusTrigger = `${year}-${month}-${pageNumber}`;

  const monthName = getMonthName(Number(year), Number(month) - 1);

  useEffect(() => {
    if (!focusTrigger) {
      return;
    }

    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    headingRef.current?.focus({ preventScroll: true });
  }, [focusTrigger]);

  return (
    <h2 ref={headingRef} className={styles.header} tabIndex={-1}>
      <Typography size="medium" component="span">
        Oferty archiwalne{" "}
        {`${monthName.at(0)?.toLowerCase()}${monthName.slice(1)}`} {year}
      </Typography>
    </h2>
  );
};

export default DynamicHeader;
